






import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import DashboardHeader from '../components/Headers/DashboardHeader';
import { Box, useMediaQuery, Drawer } from '@mui/material';
import useHealthCheck from "../pages/Hooks/HealthCheck"
const HEADER_HEIGHT = 64;
const SIDEBAR_WIDTH = 210;

const DashboardLayout = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openHeaderMenu, setOpenHeaderMenu] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
    // useHealthCheck();


  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : `${SIDEBAR_WIDTH}px 1fr`,
        gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      {/* Sidebar (Desktop Only) */}
      {!isMobile && (
        <Box
          sx={{
            gridRow: '1 / span 2',
            gridColumn: '1 / 2',
            borderRight: '1px solid #ddd',
            backgroundColor: '#fff',
            zIndex: 1200,
          }}
        >
          <Sidebar />
        </Box>
      )}

      {/* Drawer (Mobile Only) */}
      {isMobile && (
        <Drawer
          anchor="left"
          open={openSidebar}
          onClose={() => setOpenSidebar(false)}
        >
          <Sidebar mobile onClose={() => setOpenSidebar(false)} />
        </Drawer>
      )}

      {/* Header */}
      <Box
        sx={{
          gridColumn: isMobile ? '1 / 2' : '2 / 3',
          gridRow: '1 / 2',
          position: 'fixed',
          top: 0,
              left: isMobile ? 0 : SIDEBAR_WIDTH, // 👉 align with sidebar
    width: isMobile ? '100%' : `calc(100% - ${SIDEBAR_WIDTH}px)`,
        ml:isMobile?0:1,
   
          zIndex: 1100,
          backgroundColor: '#fff',
          borderBottom: '1px solid #ddd',
        }}
      >
        <DashboardHeader
          isMobile={isMobile}
          toggleSidebar={() => setOpenSidebar(true)}
          toggleHeaderMenu={() => setOpenHeaderMenu(!openHeaderMenu)}
          showHeaderMenu={openHeaderMenu}
        />
      </Box>

      {/* Scrollable Outlet Content */}
      <Box
        sx={{
          gridColumn: isMobile ? '1 / 2' : '2 / 3',
          gridRow: '2 / 3',
          overflowY: 'auto',
          backgroundColor: '#F9FAFB',
          px: isMobile ? 0.5 : 1.5,
          py: 2,
          ml:isMobile?0:1.5,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;




